module.exports = __webpack_public_path__ + "static/media/10_l_Layer1_0_0.6c7d89b8.png";